<template>
  <div class="app" :class="{ 'dark': ui === 'dark' }">
    <transition name="fade">
      <div class="overlay" v-show="sidebarOpen" @click="toggleSidebar"/>
    </transition>
    <transition name="fade">
      <div class="overlay overlay--context" v-if="isMobile" v-show="!contextSlotHidden" @click="_onContextSlotOutsideClick"/>
    </transition>
    <transition name="sidebar">
      <app-sidebar v-show="sidebarOpen" />
    </transition>
    <app-header />
    <router-view />
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex';

  import AppHeader from '@/components/AppHeader.vue';
  import AppSidebar from '@/components/AppSidebar.vue';

  export default {
    name: 'app',
    components: {
      'app-header': AppHeader,
      'app-sidebar': AppSidebar,
    },
    computed: {
      ...mapState('ui', [
        'isMobile',
        'ui',
        'sidebarOpen',
        'contextSlotHidden'
      ])
    },
    methods: {
      ...mapActions('ui', [
        'toggleSidebar',
        'setContextSlotState',
        'setIsMobile'
      ]),
      _onContextSlotOutsideClick() {
        this.setContextSlotState(true);
      }
    },
    watch: {
      '$route' () {
        this.toggleSidebar();
        if (this.isMobile && !this.contextSlotHidden) {
          this.setContextSlotState(true);
        }
      }
    },
    created() {
      this.setIsMobile(window.innerWidth <= 640);
      this.setContextSlotState(window.innerWidth <= 640);
      window.addEventListener('resize', () => {
        this.setIsMobile(window.innerWidth <= 640);
        this.setContextSlotState(window.innerWidth <= 640);
      })
    }
  }
</script>

<style lang="scss">
  .app {
    height: 100%;
    background: #fff;
    color: #000;

    &.dark {
      background: #000;
      color: #fff;
    }
  }
  .overlay {
    width: 100vw;
    height: 100vh;
    position: fixed;
    z-index: 40;
    background: rgba(0, 0, 0, 0.25);

    &.overlay--context {
      z-index: 10;
    }
    
    .app.dark & {
      background: rgba(150, 150, 150, 0.05);
    }
  }

  .sidebar-enter-active, .sidebar-leave-active {
    transition: all 500ms cubic-bezier(0.645, 0.045, 0.355, 1);
  }

  .sidebar-enter, .sidebar-leave-to {
    transform: translateX(20rem);

    @media screen and (max-width: 40rem) {
      transform: translateX(75vw);
    }
  }
  
  .fade-enter-active, .fade-leave-active {
    transition: all 500ms cubic-bezier(0.645, 0.045, 0.355, 1);;
  }
  
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
</style>
